export default function downloadBase64 (filename, type, base64) {
    const url = `data:${type};base64,${base64}`
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    document.body.appendChild(a)
    a.click()
    URL.revokeObjectURL(url)
    a.remove()
}
